import { render, staticRenderFns } from "./RegisterSeller.vue?vue&type=template&id=600b126e"
import script from "./RegisterSeller.vue?vue&type=script&lang=js"
export * from "./RegisterSeller.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports